const canonicalSlug = "[a-z0-9]+(?:-[a-z0-9]+)*";
const indexablePath = new RegExp(
  `^(?:/|/catalogo/?|/categoria/${canonicalSlug}/?|/produto/${canonicalSlug}/?)$`,
  "u",
);

export type RobotsContent = "index,follow" | "noindex,nofollow";

export function robotsContent(
  pathname: string,
  search = "",
): RobotsContent {
  const normalizedPathname =
    pathname.length > 1 &&
    pathname.endsWith("/") &&
    !pathname.endsWith("//")
      ? pathname.slice(0, -1)
      : pathname;
  const hasArbitraryQuery =
    (normalizedPathname === "/catalogo" ||
      normalizedPathname.startsWith("/categoria/")) &&
    new URLSearchParams(search).has("q");
  if (hasArbitraryQuery) {
    return "noindex,nofollow";
  }
  return indexablePath.test(pathname)
    ? "index,follow"
    : "noindex,nofollow";
}
